module.exports = __webpack_public_path__ + "static/media/locked_icon.652ecb0d.svg";